// import logo from './logo.svg';
import './App.css';
import MainMapa from './MainMapa';
// import SituacaoEnvio from './SituacaoEnvio';
import SituacaoEnvioObjetos from './SituacaoEnvioObjetos';
import SituacaoEnvioURsDFs from './SituacaoEnvioURsDFs';
import ObjetoParticipantes from './ObjetoParticipantes';
import EnvioMedia from './EnvioMedia';
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <div className="App" >
        <Routes>
          <Route element={<MainMapa  />} path="/api-fo-sp/mapa"  exact />
          <Route element={<SituacaoEnvioURsDFs  />} path="/api-fo-sp/situacao" exact />
          <Route element={<SituacaoEnvioObjetos />} path="/api-fo-sp/situacao/objetos" exact />
          <Route element={<SituacaoEnvioURsDFs />} path="/api-fo-sp/situacao/urdf" exact />
          <Route element={<ObjetoParticipantes />} path="/api-fo-sp/situacao/objetos/participante" exact />
          {/* <Route element={<EnvioMedia />} path="/api-fo-sp/fotos" exact /> */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;